import { useState } from 'react'

const useExpandAll = () => {
  const [isOpenAll, setIsOpenAll] = useState(false)
  const [clickedOnExpandAll, setClickedOnExpandAll] = useState(false)

  const toggleAll = () => {
    if (isOpenAll) {
      setClickedOnExpandAll(true)
    }
    setIsOpenAll(!isOpenAll)
  }

  return {
    toggleAll,
    setIsOpenAll,
    setClickedOnExpandAll,
    clickedOnExpandAll,
    isOpenAll,
  }
}

export default useExpandAll
